import { KeyboardEvent, useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { RentalLocationType } from '~/data/types/rentalLocationsType';
import { KEYBOARD_TYPES } from '~/data/constants';
import { ARIA_LABELS_RESOURCES } from '~/resources/resources';
import classes, { BranchAddressTextStyle, BranchNameTextStyle } from './styles';
import LocationPinIcon from '~/assets/icons/jsx/LocationIcon';

type RentalBranchProps = {
  location: RentalLocationType;
  region: string;
  onClickLocation: (
    // eslint-disable-next-line no-unused-vars
    location: RentalLocationType,
  ) => void;
};

const Location = ({ location, onClickLocation, region }: RentalBranchProps) => {
  const saveSelectedLocation = useCallback(() => {
    onClickLocation(location);
  }, [location, onClickLocation]);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent | undefined) => {
      if (event?.key === KEYBOARD_TYPES.ENTER) {
        onClickLocation(location);
      }
    },
    [location, onClickLocation],
  );

  return (
    <Box
      sx={classes.root}
      onClick={saveSelectedLocation}
      onKeyDown={handleKeyDown}
      aria-label={`${ARIA_LABELS_RESOURCES.BRANCH_REGION} ${region}, ${location.name}, ${location.address}`}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      // tabIndex={0}
    >
      <Box sx={classes.textContainer}>
        <Box sx={classes.header}>
          <Typography sx={BranchNameTextStyle}>{location.name}</Typography>
        </Box>
        <Typography style={BranchAddressTextStyle}>
          <LocationPinIcon />
          {location.address}
        </Typography>
      </Box>
    </Box>
  );
};

export default Location;
